module.exports = __webpack_public_path__ + "img/ia-04-1.1f81d06f.jpg";